import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';


import StaffOjtModal from './Elements/StaffOjtModal';

class StaffOjtsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      examiner_id: null,
      ojt_id: null,
      base_id: null,
      date_start: null,
      date_finish: null,
      runs: null,
      trained_role: 'Exec. Mnt',
      trained_role_other: null,
      trained_role_other_style: {display: 'hidden'},
      type: null,
      reference: '',
      brands: '',
      service_order: '',
      rta: '',
      report: null,
      other_reference: null,
      result: null,
      observations: null,
      aircraft_model_ids: null,
      aircraft_model_subtype_ids: null,
      manufacturer_ids: null,
      item_ids: null,
      add_message: 0,
      aircraft_models: [],
      aircraft_model_subtypes: [],
      manufacturers: [],
      bases: [],
      items: [],
      types: [],
      ojts: [],
      ojt_roles_type_m: [],
      ojt_roles_type_d: [],
      staffs: [],
      staff_ojts: {},
     };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.showOjtModal = this.showOjtModal.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleSelectMultiChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ojt/colaborador/info/edicao';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            aircraft_models: responseJson.data.aircraft_models,
            aircraft_model_subtypes: responseJson.data.aircraft_model_subtypes,
            manufacturers: responseJson.data.manufacturers,
            bases: responseJson.data.bases,
            items: responseJson.data.items,
            types: responseJson.data.types,
            ojts: responseJson.data.ojts,
            staffs: responseJson.data.staffs,
            staff_ojts: responseJson.data.main,
            ojt_roles_type_m: responseJson.data.ojt_roles_type_m,
            ojt_roles_type_d: responseJson.data.ojt_roles_type_d,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
     });
    });
  }


  add(event) {
    event.preventDefault();
    var datasave = {
      ojt_id: this.state.ojt_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      trained_role: this.state.trained_role,
      trained_role_other: this.state.trained_role_other,
      brands: this.state.brands,
      reference: this.state.reference,
      type: this.state.type,
      runs: this.state.runs,
      aircraft_model_ids: this.state.aircraft_model_ids,
      aircraft_model_subtype_ids: this.state.aircraft_model_subtype_ids,
      manufacturer_ids: this.state.manufacturer_ids,
      item_ids: this.state.item_ids,
      service_order: this.state.service_order,
      rta: this.state.rta,
      report: this.state.report,
      base_id: this.state.base_id,
      examiner_id: this.state.examiner_id,
      result: this.state.result,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ojt/colaborador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData(responseJson);
        self.showOjtModal(responseJson.data, 'event');
        self.setState({add_message: 1});
      }).catch((error) => {
        console.error(error);
      });
    });   
  }
  showOjtModal (value, event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ojt/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_staff_ojt:responseJson.data.main});
          self.setState({staff_ojt_aircraft_models:responseJson.data.aircraft_models});
          self.setState({staff_ojt_aircraft_model_subtypes:responseJson.data.aircraft_model_subtypes});
          self.setState({staff_ojt_manufacturers:responseJson.data.staff_ojt_manufacturers});
          self.setState({staff_ojt_items:responseJson.data.staff_ojt_items});
          self.setState({examiner:responseJson.data.examiner});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }
  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  
  modalPropsOff (event) {
    this.setState({ modal_props: false, add_message: 0});
  }
  
  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title">Gerenciar OJT</h3>
      <hr/>
      <StaffOjtModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} staff_ojt_aircraft_models={self.state.staff_ojt_aircraft_models} staff_ojt_aircraft_model_subtypes={self.state.staff_ojt_aircraft_model_subtypes} staff_ojt_manufacturers={self.state.staff_ojt_manufacturers} staff_ojt_items={self.state.staff_ojt_items} data_staff_ojt={self.state.data_staff_ojt}  examiner={self.state.examiner}  add_message={self.state.add_message} />
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Adicionar OJT">
          <h4>Adicionar OJT</h4>
          <hr/>
          <form onSubmit={this.add}>
            <div className="row">
              <div className="col-md-12 form-group">
                <label>Tarefa:</label>
                <Select
                  className="form-field-name"
                  name="ojt_id"
                  value={this.state.ojt_id}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'ojt_id')}
                  options={this.state.ojts}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Data de início:</label>
                <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
              </div>
              <div className="col-md-6 form-group">
                <label>Data de fim:</label>
                <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Execuções:</label>
                <input type="number" className="form-control" name="runs" value={this.state.runs} onChange={this.handleChange.bind(this, 'runs')} required />
              </div>
              <div className="col-md-6 form-group">
                <label>Função treinada:</label>
                <Select
                  className="form-field-name"
                  name="trained_role"
                  value={this.state.trained_role}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'trained_role')}
                  options={[
                    {value: 'Exec. Mnt', label: 'Exec. Mnt'},
                    {value: 'Insp. Mnt', label: 'Insp. Mnt'},
                    {value: 'Outros', label: 'Outros'},
                  ]}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Referência técnica:</label>
                <input type="text" className="form-control" name="reference" value={this.state.reference} onChange={this.handleChange.bind(this, 'reference')} placeholder="Preencha com N/A caso não seja aplicável" required />
              </div>
              <div className="col-md-6 form-group">
                <label>Marcas S/N:</label>
                <input type="text" className="form-control" name="brands" value={this.state.brands} onChange={this.handleChange.bind(this, 'brands')} placeholder="Preencha com N/A caso não seja aplicável" required />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Tipo:</label>
                <Select
                  className="form-field-name"
                  name="type"
                  value={this.state.type}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'type')}
                  options={this.state.types}
                  required
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Frotas:</label>
                <Select
                  className="form-field-name"
                  name="aircraft_model_ids"
                  value={this.state.aircraft_model_ids}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'aircraft_model_ids')}
                  options={this.state.aircraft_models}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Motores:</label>
                <Select
                  className="form-field-name"
                  name="aircraft_model_subtype_ids"
                  value={this.state.aircraft_model_subtype_ids}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'aircraft_model_subtype_ids')}
                  options={this.state.aircraft_model_subtypes}
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Fabricante:</label>
                <Select
                  className="form-field-name"
                  name="manufacturer_ids"
                  value={this.state.manufacturer_ids}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'manufacturer_ids')}
                  options={this.state.manufacturers}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Itens avulsos:</label>
                <Select
                  className="form-field-name"
                  multi={true}
                  name="item_ids"
                  value={this.state.item_ids}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectMultiChange.bind(this, 'item_ids')}
                  options={this.state.items}
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Ordem de serviço:</label>
                <input type="text" className="form-control" name="service_order" value={this.state.service_order} onChange={this.handleChange.bind(this, 'service_order')} placeholder="Preencha com N/A caso não seja aplicável" required />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>RTA:</label>
                <input type="text" className="form-control" name="rta" value={this.state.rta} onChange={this.handleChange.bind(this, 'rta')} placeholder="Preencha com N/A caso não seja aplicável" required />
              </div>
              <div className="col-md-6 form-group">
                <label>Relatório:</label>
                <input type="text" className="form-control" name="report" value={this.state.report} onChange={this.handleChange.bind(this, 'report')} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Base:</label>
                <Select
                  className="form-field-name"
                  name="base_id"
                  value={this.state.base_id}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'base_id')}
                  options={this.state.bases}
                  
                />
              </div>
              <div className="col-md-6 form-group">
                <label>Avaliador responsável:</label>
                <Select
                  className="form-field-name"
                  name="examiner_id"
                  value={this.state.examiner_id}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'examiner_id')}
                  options={this.state.staffs}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>Satisfatório:</label>
                <Select
                  className="form-field-name"
                  name="result"
                  value={this.state.result}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'result')}
                  options={[
                    {value: 'SIM', label: 'SIM'},
                    {value: 'NÃO', label: 'NÃO'},
                  ]}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 form-group">
                <label>Observações:</label>
                <textarea type="textarea" className="form-control" name="observations" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} required />
              </div>
            </div>
            <hr/>
            <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar OJT</button>
          </form>
        </Tab>
        <Tab eventKey={2} title="OJTs realizados">
          <h4>OJT cadastrados</h4>
          <hr/>
          <table className="table table-bordered table-stripped table-hover">
            <thead>
              <tr>
                <th className="text-center">Tarefa</th>
                <th className="text-center">Data final</th>
                <th className="text-center">Função treinada</th>
                <th className="text-center">Frota</th>
                <th className="text-center">Motor</th>
                <th className="text-center">Base</th>
                <th className="text-center">Satisfatório</th>
                <th className="text-center">Status</th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody id="suppliers-certifications">
              {Object.keys(self.state.staff_ojts).map(function(k) {
                return (
                  <tr>
                    <td className="text-center">{self.state.staff_ojts[k].ojt.name}</td>
                    <td className="text-center">{self.state.staff_ojts[k].date_finish_str}</td>
                    <td className="text-center">{self.state.staff_ojts[k].trained_role}</td>
                    <td className="text-center">{self.state.staff_ojts[k].aircraft_model_name}</td>
                    <td className="text-center">{self.state.staff_ojts[k].aircraft_model_subtype_name}</td>
                    <td className="text-center">{self.state.staff_ojts[k].base_name}</td>
                    <td className="text-center">{self.state.staff_ojts[k].result}</td>
                    <td className="text-center">
                      {(self.state.staff_ojts[k].status_str == 'Aprovado') ? <span className="label label-success">{self.state.staff_ojts[k].status_str}</span> : '' }
                      {(self.state.staff_ojts[k].status_str == 'Reprovado') ? <span className="label label-danger">{self.state.staff_ojts[k].status_str}</span> : '' }
                      {(self.state.staff_ojts[k].status_str == 'Pendente') ? <span className="label label-warning">{self.state.staff_ojts[k].status_str}</span> : '' }
                    </td>
                    <td className="text-center"><button onClick={self.showOjtModal.bind(self, self.state.staff_ojts[k])}  className="btn btn-info"><i className="fa fa-fw fa-eye"></i></button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Tab>
        <Tab eventKey={4} title="Tarefas pendentes">
          <h4>OJTs pendentes</h4>
          <hr/>
          <div className="row">
            <div className="col-md-6">
              <h4 className="page-title">Mandatório</h4>
              <hr/>
              <table className="table table-hover tabled-striped table-bordered">
                <thead>
                  <tr>
                    <th>Tarefa</th>
                    <th>Fabricante</th>
                    <th>Grupo</th>
                    <th>Frota</th>
                    <th>Motor</th>
                    <th>Pendência</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.ojt_roles_type_m).map(function(k) {
                    return (
                      <tr>
                        <td className="text-center">{self.state.ojt_roles_type_m[k].ojt_name}</td>
                        <td className="text-center">{self.state.ojt_roles_type_m[k].manufacturer}</td>
                        <td className="text-center">{self.state.ojt_roles_type_m[k].group}</td>
                        <td className="text-center">{self.state.ojt_roles_type_m[k].aircraft_model_name}</td>
                        <td className="text-center">{self.state.ojt_roles_type_m[k].aircraft_model_subtype_name}</td>
                        <td className="text-center">{self.state.ojt_roles_type_m[k].total_left > 0 ? <span className="label label-danger">{self.state.ojt_roles_type_m[k].total_left}</span> : <span className="label label-success">Realizada</span>}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="col-md-6">
              <h4 className="page-title">Desejado</h4>
              <hr/>
              <table className="table table-hover tabled-striped table-bordered">
                <thead>
                  <tr>
                    <th>Tarefa</th>
                    <th>Fabricante</th>
                    <th>Grupo</th>
                    <th>Frota</th>
                    <th>Motor</th>
                    <th>Pendência</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(self.state.ojt_roles_type_d).map(function(k) {
                    return (
                      <tr>
                        <td className="text-center">{self.state.ojt_roles_type_d[k].ojt_name}</td>
                        <td className="text-center">{self.state.ojt_roles_type_d[k].manufacturer}</td>
                        <td className="text-center">{self.state.ojt_roles_type_d[k].group}</td>
                        <td className="text-center">{self.state.ojt_roles_type_d[k].aircraft_model_name}</td>
                        <td className="text-center">{self.state.ojt_roles_type_d[k].aircraft_model_subtype_name}</td>
                        <td className="text-center">{self.state.ojt_roles_type_d[k].total_left > 0 ? <span className="label label-danger">{self.state.ojt_roles_type_d[k].total_left}</span> : <span className="label label-success">Realizada</span>}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default StaffOjtsEdit;



// WEBPACK FOOTER //
// ./src/Components/StaffOjts/StaffOjtsEdit.js